import * as types from "../types/warningPopup"

export const showWarningTopup = (message) => ({
  type: types.SHOW_WARNING_POPUP,
  message
})

export const hideWarningTopup = () => ({
  type: types.HIDE_WARNING_POPUP
})